<template>
  <div>
    <popup-hint hint="bulkcontainertypes">
      <template v-slot:breadcrumbs>
        <breadcrumbs :back="[{text:'Bulk containers',to:{name:'InventoryBulkContainers'}}]" home="Bulk container types"/>
      </template>
      <template v-slot:top>
        Bulk container types are used to conveniently classify your bulk containers.
      </template>
      <template v-slot:actions="{close}">
        <v-btn @click="close()" :to="{name:'InventoryBulkContainersTypesEditNew'}" color="primary" class="ml-4" small>Create</v-btn>
      </template>
    </popup-hint>

    <purtrak-table name="bulkcontainertypes" objectType="bulk container types" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   listEndPoint="bulkContainerTypes2"
                   fields="id,name,capacity"
                   :listFilters="[]"
                   @dblclick="type => $router.push({name:'InventoryBulkContainersTypesEdit',params:{id:type.id}})"
                   title="Bulk container types"
                   :print-info="{pageSize:'portrait', subTitle:[]}"
                   download-endpoint="bulkContainerTypesExportCSV">
      <template v-slot:menu v-if="!readOnly">
        <v-list-item :to="{name:'InventoryBulkContainersTypesEditNew'}"><v-list-item-title>Create new type</v-list-item-title></v-list-item>
      </template>
      <template v-slot:item.capacity="{value}">
        {{value}} litres
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'InventoryBulkContainersTypesEditNew'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-btn small icon @click.stop="typeToDelete=item;showDelete=true"><v-icon small>mdi-delete</v-icon></v-btn>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" name="this bulk container type" @delete="performDeleteType"/>
  </div>
</template>

<script>

export default {
  name: 'InventoryBulkContainersTypes',
  data() {
    return {
      typeToDelete: {},
      showDelete: false,
      defaultColumns: [{ value: 'name', visible:true},
                       { value: 'capacity', visible:true}],
      headers: [{ text: 'TYPE', value: 'name', width:'60%',sortable:true},
                { text: 'CAPACITY', value: 'capacity', width:'35%',sortable:true}]
    }
  },
  computed: {
    readOnly() {
      return !this.$store.getters.company.permissions.includes('inventory.write');
    }
  },
  methods: {
    async performDeleteType() {
      this.loading = true;
      const results = await this.$apiCall(`mutation InventoryBulkContainersTypes($id: ID!) {
                                                bulkContainerTypeDelete(id:$id) {
                                                  id
                                                }
                                              }`,
                                          {id:this.typeToDelete.id});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        this.$refs.table.buildList();
        this.$store.commit('setError', {type:'success',message:`Deleted bulk container type ${this.typeToDelete.name}`});
      }
    },
  }
}
</script>